import { render, staticRenderFns } from "./knowledge3.vue?vue&type=template&id=ee3dbda4&scoped=true"
import script from "./knowledge3.vue?vue&type=script&lang=js"
export * from "./knowledge3.vue?vue&type=script&lang=js"
import style0 from "./knowledge3.vue?vue&type=style&index=0&id=ee3dbda4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3dbda4",
  null
  
)

export default component.exports